import React, {Component} from 'react';
import InnerLoading from "../Viabilidade/InnerLoading";
import {InputSwitch} from "primereact/inputswitch";
import ResultCard from "./ResultCard";
import Pagination from "react-js-pagination";
import {Dropdown} from "primereact/dropdown";


class ListaResultadosColetados extends Component{

    constructor(props) {
        super(props);

    }

    perPageOptions = [
        {
            label: 5,
            value: 5
        }, {
            label: 10,
            value: 10
        },{
            label: 20,
            value: 20
        },{
            label: 30,
            value: 30
        },{
            label: 50,
            value: 50
        },{
            label: 100,
            value: 100
        },

    ]

    render(){
        return(
            <React.Fragment>
                {this.props.loading && <InnerLoading/>}
                <div className="d-flex justify-content-center align-items-center" style={{marginBottom: '2px'}}>
                    <div style={{width: '50%'}}>
                        <span className="smal text-muted">Exibindo Resultados de {this.props.pagination.from} até {this.props.pagination.to} de um total de {this.props.pagination.total}</span>
                    </div>

                    <div style={{width: '50%'}} className="float-right">
                       <div className="float-right">
                           <label className="control-label">Resultados por Página</label> &nbsp;
                           <Dropdown
                               value={this.props.pagination.per_page}
                               onChange={this.props.handlePerPageChanged} options={this.perPageOptions}
                               placeholder="Selecione Um Valor" className="w-full md:w-14rem" />
                       </div>
                    </div>
                </div>

                {this.props.coletas.map((coleta, index) => {
                    return (
                        <ResultCard
                            key={index} coleta={coleta}
                            cadastrarEmpreendimento={this.props.cadastrarEmpreendimento}
                            showModalIgnorarColeta={this.props.showModalIgnorarColeta}
                            openBuscaEmpreendimentoComFiltros={this.props.openBuscaEmpreendimentoComFiltros}
                        />
                    );
                })}

                <div className="d-flex justify-content-center">
                    <Pagination
                        activePage={this.props.pagination.current_page}
                        itemsCountPerPage={this.props.pagination.per_page}
                        totalItemsCount={this.props.pagination.total}
                        pageRangeDisplayed={10}
                        onChange={this.props.handlePageChange}
                        itemClass="page-item"
                        linkClass="page-link"
                    />
                </div>
            </React.Fragment>
        )
    }
}

export default ListaResultadosColetados;
